module.exports = __webpack_public_path__ + "img/31.389cc94.png";